import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Дашборд ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Новости ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Редактировать ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showBreadcrumbs)
      ? (_openBlock(), _createBlock(_component_el_breadcrumb, {
          key: 0,
          "separator-class": "el-icon-arrow-right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { name: 'dashboards' } }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, { to: { name: 'news' } }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, { to: { name: 'news' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.breadcrumbs), 1)
  ]))
}